import { isSetupAllowedForUser, isSetupCompleted } from 'utils/setupStorage'
import { useSelector } from 'react-redux'
import { RootState } from 'constants/interfaces'

export const useDynamicContentHeight = () => {
  const uid = useSelector((state: RootState) => state.auth.uid)
  const isSetupComplete = isSetupCompleted(uid!)
  const isAllowedToAccessSetup = isSetupAllowedForUser(uid!)

  const getCalculatedHeight = () => {
    if (!isAllowedToAccessSetup) {
      return '100vh'
    }
    if (isAllowedToAccessSetup && isSetupComplete) {
      return '100vh'
    }
    return '93vh'
  }
  return getCalculatedHeight()
}
